export const BET_CARD_CLASS_NAME = 'bet-card';
export const BET_CARD_BODY_CLASS_NAME = `${BET_CARD_CLASS_NAME}__body`;
export const BET_CARD_DETAILS_CLASS_NAME = `${BET_CARD_CLASS_NAME}__details`;
export const BET_CARD_TIMER_CLASS_NAME = `${BET_CARD_CLASS_NAME}__timer`;
export const BET_CARD_LABEL_CLASS_NAME = `${BET_CARD_CLASS_NAME}__label`;
export const BET_CARD_SUSPENDED_CLASS_NAME = `${BET_CARD_CLASS_NAME}__suspended`;
export const BET_CARD_SUSPENDED_THREE_MARKET_CLASS_NAME = `${BET_CARD_SUSPENDED_CLASS_NAME}--three-market`;
export const BET_CARD_SUSPENDED_EVENT_CLASS_NAME = `${BET_CARD_SUSPENDED_CLASS_NAME}--event`;
export const BET_CARD_BET_BUTTONS_CLASS_NAME = `${BET_CARD_CLASS_NAME}__bet-buttons`;
export const BET_CARD_LIVE_TAG_CLASS_NAME = `${BET_CARD_CLASS_NAME}__live-tag`;
export const BET_CARD_FOOTER_CLASS_NAME = `${BET_CARD_CLASS_NAME}__footer`;

const I18N_PREFIX = 'sport_event';

export const BET_CARD_LIVE_TAG_TEXT = `${I18N_PREFIX}.live`;
export const BET_CARD_SUSPENDED_TEXT = `${I18N_PREFIX}.suspended`;
